import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { Button, Card, Col, Container, Form, Row } from "react-bootstrap";
import  DeleteConfirmDialog  from './DeleteConfirmDialog';
import { axiosAuth_DATA_MGMT_API } from '../utils/AxoisUtilComponent';
import { axiosAuth_PLATFORM_API } from '../utils/AxoisUtilComponent';
import { useTranslation } from 'react-i18next';
import classes from './AdminPages.module.css';
import { translateAPIError } from '../utils/apiUtils';
import { LoadingSpinner } from '../utils/uiUtils';


const DocAdminNewView = (props) => {

  // Utilities
  const { t } = useTranslation(['common', 'custom']);
  const navigate = useNavigate();

  // Initialize with actual JSON obj.  If not, will get error.
  const [objAttrs, setObjAttrs] = useState({
    name: '',
    displayName: '',
    path: '',
    description: '',
    category: '',
    tags: '',
    fileType: 'Test',
    fileExt: '.txt',
    size: '',
    selectedFile: ''
  });

  const [docMgmtConfig, setDocMgmtConfig] = useState(null);
  const [totalSize,     setTotalSize]     = useState(null);

  const [loading, setLoading] = useState(false);


  // Initialize state
  useEffect(() => {

    fetchDocMgmtConfig();
    fetchDocStoreUsage();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  const fetchDocMgmtConfig = () => {

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_PLATFORM_API.get("business-configs?name=DOC_MANAGEMENT");

        resolve(res.data);

        if (res.status === 200) {
          setDocMgmtConfig(res.data[0].config);
        }

        setErrMsg('');
      } catch (error) {
        setErrMsg(t(translateAPIError(error)));
      }
    });
  }

  const fetchDocStoreUsage = () => {

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_DATA_MGMT_API.get("docs?searchTerms=&limit=1&offset=0");

        resolve(res.data);

        if (res.status === 200) {
          setTotalSize(res.data.totalSize);
        }

        setErrMsg('');
      } catch (error) {
        setErrMsg(t(translateAPIError(error)));
      }
    });
  }


  // UI Functions

  const [errMsg, setErrMsg] = useState('');

  const [overwriteTarget,            setOverwriteTarget]            = useState(null);
  const [showOverwriteConfirmDialog, setShowOverwriteConfirmDialog] = useState(false);
  const [errMsgOverwriteConfirm,     setErrMsgOverwriteConfirm]     = useState('')

  const onAttrsInputChange = (e) => {
    setObjAttrs({ ...objAttrs, [e.target.name]: e.target.value })
  }


  const handleFileChange = (event) => {

    // Protect from Cancel event where the event.target.files[0] is not defined.
    if (event.target && event.target.files[0]) {

      // Check to see if file size exceeds limit and there is sufficient storage quota
      if (event.target.files[0].size > (docMgmtConfig.fileSizeLimit * 1024.0)) {
        setErrMsg(t("I18N_ERR_File_size_exceed_limit") + docMgmtConfig.fileSizeLimit);
        return;
      } else if (event.target.files[0].size + (totalSize * 1.0) > docMgmtConfig.docStoreQuota * 1024.0) {
        setErrMsg(t("I18N_ERR_Insufficient_storage_quota") + event.target.files[0].name);
        return;
      }

      // Deep copy
      let tmpAttrs = JSON.parse(JSON.stringify(objAttrs));
      tmpAttrs.selectedFile = event.target.files[0];
      tmpAttrs.name         = event.target.files[0].name;
      tmpAttrs.displayName  = event.target.files[0].name;
      tmpAttrs.size         = event.target.files[0].size;
      tmpAttrs.fileType     = event.target.files[0].type;
      tmpAttrs.path         = "/igc-doc-store/" + event.target.files[0].name;
      tmpAttrs.fileExt      = getSubstringAfterLastPeriod(event.target.files[0].name);

      setObjAttrs(tmpAttrs);
    }
  };

  function getSubstringAfterLastPeriod(str) {
    const lastPeriodIndex = str.lastIndexOf('.');
    if (lastPeriodIndex === -1) {
      // No period found, return the null
      return (null);
    }
    return str.substring(lastPeriodIndex + 1);
  }

  const handleCreateCancel = (e) => {
    e.preventDefault();

    // Return to list
    navigate(-1);
  }


  const handleCreateSubmit = (e) => {
    e.preventDefault();

    // Validate form inputs
    if (!objAttrs.name || objAttrs.name.trim().length === 0) {
      setErrMsg(t("I18N_ERR_Need_select_file"));
      return;
    } else if (!objAttrs.displayName || objAttrs.displayName.trim().length === 0) {
      setErrMsg(t("I18N_ERR_Need_display_name"));
      return;
    } else if (objAttrs.displayName.length > 250) {
      setErrMsg(t("I18N_ERR_Max_len_display_name") + 250);
      return;
    } else if (objAttrs.description && (objAttrs.description != null) && objAttrs.description.length > 250) {
      setErrMsg(t("I18N_ERR_Max_len_desc") + 250);
      return;
    } else if (objAttrs.category && (objAttrs.category != null) && objAttrs.category.length > 20) {
      setErrMsg(t("I18N_ERR_Max_len_cat") + 20);
      return;
    } else if (objAttrs.tags && (objAttrs.tags != null) && objAttrs.tags.length > 250) {
      setErrMsg(t("I18N_ERR_Max_len_tags") + 250);
      return;
/*
    } else if (objAttrs.size > (docMgmtConfig.fileSizeLimit * 1024.0)) {
      setErrMsg(t("I18N_ERR_File_size_exceed_limit") + docMgmtConfig.fileSizeLimit);
      return;
*/
    }

    // Check for doc name availability
    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_DATA_MGMT_API.get("docs?name=" + encodeURIComponent(objAttrs.name));

        if (res.data.length > 0) {
          setOverwriteTarget(res.data[0]);
          setShowOverwriteConfirmDialog(true);
        } else {
          doDocCreate();
        }

        setErrMsg('');
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg(t(translateAPIError(error)));
        }
      }
    });

  }


  function doDocCreate() {

    return new Promise(async (resolve, reject) => {

      setLoading(true); // For loading spinner

      try {

        // Deep copy
        let reqBody = JSON.parse(JSON.stringify(objAttrs));

        if (overwriteTarget == null) {
          // --- Creation Mode ---
          const data = new FormData();
          data.append('name', objAttrs.name);
          data.append('displayName', objAttrs.displayName);
          data.append('path', objAttrs.path);
          data.append('fileExt', objAttrs.fileExt);
          data.append('fileType', objAttrs.fileType);
          data.append('size', objAttrs.size);
          data.append('tags', objAttrs.tags);
          data.append('description', objAttrs.description);
          data.append('category', objAttrs.category);
          data.append('file', objAttrs.selectedFile);

          const res = await axiosAuth_DATA_MGMT_API.post("docs", data, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          });

          resolve(res.data);

          if (res.status === 201) {
            // Return to list
            navigate(-1);

            setShowOverwriteConfirmDialog(false);
          }
        } else {
          // --- Overwrite Mode ---
          const res = await axiosAuth_DATA_MGMT_API.put("docs/" + overwriteTarget.id, reqBody);

          resolve(res.data);

          if (res.status === 200) {
            // Return to list
            navigate(-1);
          }
        }

      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsgOverwriteConfirm(t(translateAPIError(error)));
        }
      }

      setLoading(false);

    });

  }


  function handleObjOverwriteCancel() {
    setOverwriteTarget(null);
    setErrMsgOverwriteConfirm('');
    setShowOverwriteConfirmDialog(false);
  }


  const handleClose = (e) => {
    e.preventDefault();

    // Return to list
    navigate(-1);
  }


  return (
    <>
      <Card style={{overflow:'auto', border:'0', boxShadow:'0 2px 2px 0px rgba(0,0,0,0.1)',
                    padding:'20px 40px 20px 40px', maxWidth:'2500px', width:'100%', fontSize:'13px'}}>

        <div style={{display:'flex'}}>
        <span className={classes.admin_pages__page_title}>
          {t("I18N_Upload_Doc")}
        </span>
        </div>

        <div className={classes.admin_pages__page_subtitle} style={{marginTop:'20px'}}>
          <div display='flex'>
            <span>
              {t("I18N_Doc_info")}
            </span>
          </div>
          <hr className="solid" style={{ margin: '0 0 10px 0' }}></hr>

          <Container>
            <form>
              <Row className={classes.admin_pages__field_label}>
                <Col>{t("I18N_File_name")}: *</Col>
                <Col></Col>
                <Col></Col>
                <Col></Col>
              </Row>
              <Row className={classes.admin_pages__field_value}>
                <Col>
                  <input readOnly className={classes.admin_pages__field_editable} style={{width:'100%'}} name="name" value={objAttrs.name} />
                </Col>
                <Col>
                  <div>
                    <input
                      type="file"
                      style={{ display: 'none' }}
                      id="fileInput"
                      onChange={handleFileChange}
                    />
                    <Button size="tiny" variant="outline-secondary" className="mb-3"
                            onClick={() => document.getElementById('fileInput').click()} >
                      {t("I18N_Choose_file")}
                    </Button>
                  </div>
                </Col>
                <Col></Col>
                <Col></Col>
              </Row>

              <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }} >
                <Col>{t("I18N_Display_name")}: *</Col>
                <Col>{t("I18N_Description")}:</Col>
                <Col>{t("I18N_Category")}:</Col>
                <Col>{t("I18N_Tags")}:</Col>
              </Row>
              <Row className={classes.admin_pages__field_value}>
                <Col>
                  <input className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="displayName" value={objAttrs.displayName}
                    onChange={(e) => onAttrsInputChange(e)} />
                </Col>
                <Col>
                  <textarea className={classes.admin_pages__field_editable} style={{minWidth: '100%', minHeight:'80px', backgroundColor:'white'}}
                            name="description" value={objAttrs.description}
                    onChange={(e) => onAttrsInputChange(e)} />
                </Col>
                <Col>
                  <input className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="category" value={objAttrs.category}
                    onChange={(e) => onAttrsInputChange(e)} />
                </Col>
                <Col>
                  <input className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="tags" value={objAttrs.tags}
                    onChange={(e) => onAttrsInputChange(e)} />
                </Col>
              </Row>

              <Row className={classes.admin_pages__field_label} style={{marginTop:'10px', fontStyle:'italic'}}>
                <span>{t("I18N_Req_fields")}</span>
              </Row>

              <Row>
                <div display='flex' style={{marginTop:'15px'}}>
                  <Button size="tiny" variant="outline-secondary" className="mb-3"
                    style={{ float: 'left' }}
                    onClick={handleCreateCancel}>
                    {t("I18N_Cancel")}
                  </Button>
                  <Button size="tiny" variant="outline-secondary" className="mb-3"
                    style={{ marginLeft: '15px' }}
                    onClick={handleCreateSubmit}>
                    {t("I18N_Upload_file")}
                  </Button>
                  <span className={classes.admin_pages__field_label} style={{marginLeft:'30px', color:'rgba(200,0,0)', verticalAlign:'top'}}>
                    {errMsg}
                  </span>
                </div>
              </Row>
            </form>
          </Container>
        </div>

        <hr className="solid" style={{ marginTop: '30px' }}></hr>

        <div className={classes.admin_pages__page_subtitle} style={{ marginTop: '20px' }}>
          <Form.Group as={Row} className="mb-2 mt-3">
            <div style={{ display: "flex" }}>
              <Button size="sm" variant="outline-secondary" className="mb-3"
                style={{ fontSize: '12px', fontWeight: '300' }}
                onClick={handleClose}>
                {t("I18N_Close")}
              </Button>
            </div>
{/*
            <span className={classes.admin_pages__field_label} style={{ color: 'rgba(200,0,0)', verticalAlign: 'top' }}>
              {updateObjErrMsg}
            </span>
*/}
          </Form.Group>
        </div>

        <DeleteConfirmDialog
          title={t("I18N_Doc_overwrite_confirm")}
          show={showOverwriteConfirmDialog}
          targetName={overwriteTarget ? overwriteTarget.name : ''}
          errMsgDeleteConfirm={errMsgOverwriteConfirm}
          onCancel={handleObjOverwriteCancel}
          onSubmit={doDocCreate}
        />

        <LoadingSpinner loading={loading} />

      </Card>
    </>
  );
}

export default DocAdminNewView;
